/* eslint-disable @next/next/no-img-element */
'use client';
/* eslint-disable i18next/no-literal-string */
import { useEffect } from 'react';

export const CustomErrorComponent = ({
  unstableRetry,
}: {
  unstableRetry: () => void;
}) => {
  return (
    <>
      <style>{`
        .ge-header {
          flex-direction: column;
          align-items: center;
          background: #fff;
          font-family: neighbourSans, Arial, Helvetica, sans-serif;
          display: block;
        }
        .ge-header-inner {
          margin: auto;
          padding: 24px 48px;
          display: flex;
          align-self: stretch;
          max-width: 1440px;
          width: 100%;
        }
        .ge-logo {
          width: 158px;
          height: 60px;
        }
        .ge-main {
          min-height: 100vh;
          flex-direction: column;
          align-items: center;
          background-color: #fff;
          margin: auto;
          font-family: neighbourSans, Arial, Helvetica, sans-serif;
          display: flex;
        }
        .ge-section {
          width: 100%;
          max-width: 1440px;
          padding: 96px 48px;
        }
        .ge-grid {
          display: grid;
          align-items: center;
          row-gap: 16px;
          column-gap: 32px;
          align-self: stretch;
          grid-template-columns: 1fr 1fr;
          grid-template-rows: auto auto;
        }
        .ge-illustration {
          width: 400px;
          height: 400px;
          max-width: 400px;
          max-height: 400px;
          aspect-ratio: 142/165;
          order: 3;
          grid-column: 2;
          grid-row: 1 / 3;
          justify-self: flex-end;
        }
        .ge-text-container {
          order: 1;
          max-width: 768px;
          align-self: flex-end;
        }
        .ge-heading {
          font-size: 64px;
          font-style: normal;
          font-weight: 600;
          line-height: 125%;
          letter-spacing: -0.8px;
          color: #000;
          padding-bottom: 20px;
        }
        .ge-paragraph {
          font-size: 16px;
          color: #4B5565;
          font-style: normal;
          font-weight: 500;
          line-height: 125%;
        }
        .ge-paragraph-last {
          padding-bottom: 16px;
        }
        .ge-buttons {
          display: flex;
          flex-direction: row;
          width: min-content;
          row-gap: 12px;
          column-gap: 12px;
          order: 2;
          align-self: flex-start;
          padding-top: 24px;
        }
        .ge-btn-primary {
          width: max-content;
          border-radius: 8px;
          border: 1px solid #2A5EEC;
          background: #2A5EEC;
          box-shadow: 0.001px 1px 2px 0.001px rgba(0, 0, 0, 0.05);
          display: flex;
          padding: 16px 24px;
          justify-content: center;
          align-items: center;
          color: #fff;
          font-size: 20px;
          font-style: normal;
          font-weight: 600;
          line-height: 125%;
          cursor: pointer;
        }
        .ge-btn-primary:hover,
        .ge-btn-primary:focus {
          background-color: #1d46d8;
          border-color: #1d46d8;
          box-shadow: 0 0 0 .25rem #2a5eec40, 0 .0625rem .125rem 0 #0000000d;
        }
        @media (max-width: 639px) {
          .ge-header-inner {
            padding: 12px 16px;
          }
          .ge-logo {
            width: 128px;
            height: 48px;
          }
          .ge-section {
            padding: 16px 32px;
          }
          .ge-grid {
            display: flex;
            flex-direction: column;
          }
          .ge-illustration {
            width: 179px;
            height: 208px;
            max-width: 274.4px;
            max-height: 320px;
            order: 1;
          }
          .ge-text-container {
            order: 2;
          }
          .ge-heading {
            font-size: 40px;
            padding-bottom: 12px;
          }
          .ge-buttons {
            flex-direction: column;
            width: 100%;
            order: 3;
            padding-top: 32px;
          }
          .ge-btn-primary {
            width: 100%;
            font-size: 16px;
          }
        }
      `}</style>
      <header className="ge-header">
        <div className="ge-header-inner">
          <a href="https://www.compassion.com">
            <img
              className="ge-logo"
              src="/compassion-logo-header.svg"
              alt="Compassion International"
            />
          </a>
        </div>
      </header>
      <main className="ge-main">
        <section className="ge-section">
          <div className="ge-grid">
            <svg
              className="ge-illustration"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 400 400"
              fill="none"
            >
              <path
                d="M213.9 43.2C211.8 88.3 209.7 133.4 207.6 178.5C214.6 177.9 221.5 177.2 228.5 176.6C225.8 131 226.9 85.1 231.8 39.7C224.8 40.2 217.7 40.8 214 43.2H213.9Z"
                fill="#A50F25"
              />
              <path
                d="M226.2 107.5C235.2 76.5 264.2 54.8 292.6 57.9C284.2 87.8 253.7 106.9 226.2 107.5Z"
                fill="#FDB518"
              />
              <path
                d="M213.8 333.9C229.1 332.8 241.1 348 255 355.3C276.6 366.6 303 357.5 321.1 339.8C339.1 322.1 350.5 297.3 360.8 272.7C375.1 238.7 388.4 199.1 375.4 164.5C362.5 130.2 325.9 113.3 293.7 119C261.5 124.7 233.7 148.6 216.4 175.2"
                fill="#2A5EEC"
              />
              <path
                d="M216.4 175.2C193 134.9 156.3 102 114.2 98.2C72.0999 94.4 26.7999 126.6 20.1999 174.4C15.8999 205.1 27.4999 236.5 44.9999 260.2C62.4999 283.9 85.4999 301.4 108.2 318.5C132.4 336.7 161.4 355.8 188.7 344.5C197.1 341 204.9 334.7 213.8 334.1"
                fill="#11265E"
              />
            </svg>
            <div className="ge-text-container">
              <h1 className="ge-heading">Thank you for your patience</h1>
              <p className="ge-paragraph">
                Patience is a fruit of the spirit! And we&#39;re practicing it
                too as we resolve this issue.
              </p>
              <p className="ge-paragraph ge-paragraph-last">
                <strong>Please try again or refresh the page.</strong>
              </p>
            </div>
            <div className="ge-buttons">
              <button
                className="ge-btn-primary"
                onClick={() => unstableRetry()}
              >
                Try Again
              </button>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

const GlobalError = ({
  error,
  unstable_retry,
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) => {
  useEffect(() => {
    if (globalThis.window) {
      if (!globalThis.window.dataLayer) {
        globalThis.window.dataLayer = [];
      }
      globalThis.window.dataLayer.push({
        event: 'error_message',
        message: error.digest || error.message,
      });
    }
  }, []);

  return (
    <html lang="en">
      <head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="robots" content="noindex" />
      </head>
      <body>
        <CustomErrorComponent unstableRetry={unstable_retry} />
      </body>
    </html>
  );
};

export default GlobalError;
